import * as ActiveStorage from "@rails/activestorage";

ActiveStorage.start();

// gem 同梱の activestorage.js は window.ActiveStorage を公開していたため
// 挙動維持のために公開しておく。
window.ActiveStorage = ActiveStorage;
